import { Action } from '@wix/wix-help-widget-common/types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { updateWidgetSession } from '../../common/api/updateWidgetSession';
import { selectWidgetSessionTabId } from '../../common/selectors/widgetSession';
import { appRoutes } from '../../routes';

/**
 * Hook for updating the widget session with the chatbot page URL.
 * We should open chatbot directly on any tab if user open ContactApp
 */
export const useUpdateCurrentUrl = () => {
  const sessionTabId = useSelector(selectWidgetSessionTabId);

  useEffect(() => {
    void updateWidgetSession({
      tabId: sessionTabId,
      action: Action.Push,
      url: appRoutes.chatbot(),
    });
  }, []);
};
